<template>
  <UserLayout pageTitle="Agenda personale">
    <template #page-content>
      <v-btn
        color="primary"
        class="mb-4"
        @click="ferieDialog = true"
        v-if="user?.role === 'operatore'"
      >
        Richiedi permesso
      </v-btn>

      <v-dialog v-model="ferieDialog" max-width="500">
        <v-card>
          <v-card-title>Seleziona i giorni di ferie</v-card-title>

          <v-card-text>
            <v-date-picker v-model="giorniSelezionati" multiple />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="chiudiDialog" :disabled="saving">Annulla</v-btn>
            <v-btn
              color="primary"
              @click="inviaRichiestaFerie"
              :loading="saving"
              :disabled="saving || normalizedDates.length === 0"
            >
              Conferma
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <AgendaViewer />
    </template>
  </UserLayout>
</template>

<script>
import AgendaViewer from "../components/CustomComponentsUI/AgendaViewer";
import UISettingsHelper from "../utils/UISettingsHelper";
import UserLayout from "../layout/UserLayout";
import EasyPlanClient from "@/utils/EasyPlanClient"; // 👈 come nell’altra pagina
import moment from "moment";

export default {
  components: {
    AgendaViewer,
    UserLayout,
  },

  data() {
    return {
      ferieDialog: false,
      giorniSelezionati: [],
      saving: false,
      user: JSON.parse(localStorage.getItem("user")) || {},
    };
  },

  created() {
    UISettingsHelper.CheckUISettings();
  },

  computed: {
    alias() {
      return this.$route.params.alias || this.$route.params.companyAlias;
    },

    // ✅ normalizza date (string YYYY-MM-DD), rimuove duplicati, ordina
    normalizedDates() {
      const raw = Array.isArray(this.giorniSelezionati) ? this.giorniSelezionati : [];
      const normalized = raw
        .map(d => moment(d).format("YYYY-MM-DD"))
        .filter(d => d && d !== "Invalid date");

      return [...new Set(normalized)].sort();
    },
  },

  methods: {
    chiudiDialog() {
      if (this.saving) return;
      this.ferieDialog = false;
    },

    async inviaRichiestaFerie() {
      if (this.normalizedDates.length === 0) {
        alert("Seleziona almeno un giorno.");
        return;
      }

      const conferma = window.confirm(
        `Inviare richiesta ferie per ${this.normalizedDates.length} giorno/i?`
      );
      if (!conferma) return;

      this.saving = true;

      // ✅ DataCreazione identica per tutti gli eventi (ms inclusi)
      const dataCreazioneUnica = new Date().toISOString();

      try {
        // Creo un evento per ogni giorno selezionato
        for (const day of this.normalizedDates) {
          const inizio = moment(day).hour(9).minute(0).second(0).millisecond(0).toISOString();
          const fine = moment(day).hour(18).minute(59).second(59).millisecond(999).toISOString();

          const payload = {
            tipo: "RichiestaPermesso",
            descrizione: "Richiesta ferie da calendario",
            note: "",
            giornoIntero: true,
            inizio,
            fine,
            rimosso: false,

            // ✅ IMPORTANTISSIMO: uguale per tutti nel batch
            dataCreazione: dataCreazioneUnica,

            // creator (se serve)
            idCreatore: this.user?.idUtente || this.user?.id || null,
          };

          // ⚠️ cambia Create con il metodo reale del tuo client
          await EasyPlanClient.Event.Create(this.alias, payload);
        }

        // chiudo e pulisco
        this.ferieDialog = false;
        this.giorniSelezionati = [];

        // se vuoi: forza refresh dell’agenda (dipende da come AgendaViewer carica)
        // this.$refs.agendaViewer?.reload?.();

      } catch (err) {
        console.error("Errore invio richiesta ferie:", err);
        alert("Errore durante l'invio della richiesta ferie. Controlla la console.");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
